import React from 'react';
import { FreetextResponsesCard } from './FreetextResponsesCard';

interface FreetextTopicsTabProps {
  leaderLogin: string;
  metricPeriod: string;
  startDate?: string;
  leaderName: string;
  periodLabel: string;
}

/**
 * Freetext detail panel.
 *
 * The aggregated per-topic P/N table ("Freetext Sentiment Topics") was consolidated into
 * the Sentiment Deep Dive charts' hover tooltips (sample size + positive%/negative% per
 * leader·topic), so this now renders only the verbatim word cloud + drill-down, sourced
 * from the raw monthly Clarity file (fact_connections_freetext_responses).
 */
export const FreetextTopicsTab: React.FC<FreetextTopicsTabProps> = ({ leaderLogin, metricPeriod, startDate, leaderName, periodLabel }) => (
  <FreetextResponsesCard
    leaderLogin={leaderLogin}
    metricPeriod={metricPeriod}
    startDate={startDate}
    leaderName={leaderName}
    periodLabel={periodLabel}
  />
);
